(function () {
  /* 
   * Optimized cart-upsell.js
   * - Removed fetch on first open (upsells already rendered server-side)
   * - Only updates upsells when cart items are removed (not on add)
   * - Uses Section Rendering API for faster updates
   */

  let isUpdating = false;
  let lastItemCount = null;

  function insertSectionCartDrawer() {
    if (document.querySelector('#CartDrawer .cart-drawer-items-wrapper')) return;

    var cartDrawerItems = document.querySelector('#CartDrawer cart-drawer-items');
    if (!cartDrawerItems) return;

    if (cartDrawerItems.classList.contains('is-empty')) return;

    var wrapper = document.createElement('div');
    wrapper.classList.add('cart-drawer-items-wrapper');
    cartDrawerItems.parentNode.insertBefore(wrapper, cartDrawerItems);
    wrapper.appendChild(cartDrawerItems);

    const upsells = document.querySelector('#cart-drawer-upsell-wrapper');
    if (upsells) {
      wrapper.insertAdjacentHTML('beforeend', upsells.innerHTML);
    }

    if (!document.querySelector('.cart-drawer-upsell-list li')) {
      const upsellEl = document.querySelector('#cart-drawer-upsell');
      if (upsellEl) upsellEl.remove();
    }
  }
  
  /* Run once on page load */
  insertSectionCartDrawer();

  window.onChangeKsUpsellVariantSelector = function(select, event) {
    event.preventDefault();
    const imgSrc = select.options[select.selectedIndex].dataset.variantImg;

    if (imgSrc) {
      const img = select.closest('.cart-drawer-upsell-list-item').querySelector('.cart-drawer-upsell-list-item-left img');
      if (img) img.src = imgSrc;
    }
  };

  async function updateUpsells() {
    if (isUpdating) return;
    isUpdating = true;

    try {
      const response = await fetch(`${window.location.pathname}?section_id=cart-drawer`);
      if (!response.ok) return;

      const text = await response.text();
      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = text;

      const newUpsellWrapper = tempDiv.querySelector('#cart-drawer-upsell-wrapper');
      const currentUpsellWrapper = document.querySelector('#cart-drawer-upsell-wrapper');

      if (newUpsellWrapper && currentUpsellWrapper) {
        currentUpsellWrapper.innerHTML = newUpsellWrapper.innerHTML;
      }

      /* Update upsell content inside the visible wrapper */
      const wrapper = document.querySelector('#CartDrawer .cart-drawer-items-wrapper');
      if (wrapper) {
        const upsells = document.querySelector('#cart-drawer-upsell-wrapper');
        const upsellInWrapper = wrapper.querySelector('#cart-drawer-upsell');
        if (upsells) {
          if (upsellInWrapper) {
            upsellInWrapper.outerHTML = upsells.innerHTML;
          } else {
            wrapper.insertAdjacentHTML('beforeend', upsells.innerHTML);
          }
        }
      }

      /* Hide upsell section if no items remain after filtering */
      if (!document.querySelector('.cart-drawer-upsell-list li')) {
        const upsellEl = document.querySelector('#cart-drawer-upsell');
        if (upsellEl) upsellEl.remove();
      }

      /* Re-init slider if available */
      if (typeof window.initCartUpsellSlider === 'function') {
        window.initCartUpsellSlider();
      }
    } catch (e) {
      /* Silently fail */
    } finally {
      isUpdating = false;
    }
  }

  /* Listen for cart updates via pub/sub (more reliable than MutationObserver) */
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      /* Update upsells when cart items change (add or remove) */
      const cartItems = document.querySelectorAll('cart-drawer-items .cart-item');
      const currentCount = cartItems.length;

      if (lastItemCount === null || currentCount !== lastItemCount) {
        setTimeout(updateUpsells, 200);
      }

      lastItemCount = currentCount;
    });
  }

  /* MutationObserver: re-create upsell wrapper after renderContents replaces #CartDrawer innerHTML */
  function observeCartDrawerForReset() {
    var cartDrawerEl = document.getElementById('CartDrawer');
    if (!cartDrawerEl) return;

    var resetTimer;
    var drawerObserver = new MutationObserver(function() {
      if (resetTimer) clearTimeout(resetTimer);
      resetTimer = setTimeout(function() {
        if (!document.querySelector('#CartDrawer .cart-drawer-items-wrapper')) {
          insertSectionCartDrawer();
          setTimeout(updateUpsells, 100);
        }
      }, 50);
    });

    drawerObserver.observe(cartDrawerEl, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observeCartDrawerForReset);
  } else {
    observeCartDrawerForReset();
  }

  /* Fallback: simple observer for cart page only (not drawer) */
  function listenCartPage() {
    const element = document.querySelector('#MainContent .cart__items');
    if (!element) return;

    let timer;

    const observer = new MutationObserver(() => {
      if (timer) clearTimeout(timer);
      timer = setTimeout(updateUpsells, 500);
    });

    observer.observe(element, {
      childList: true,
      subtree: true
    });
  }
  listenCartPage();
})();
